(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athena-bundle-builder"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('athena-bundle-builder')) return;
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  class AthenaBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-ab-data]');
      if (!data) return;
      this.ready = true;
      this.config = JSON.parse(data.textContent);
      this.products = this.config.products || [];
      this.tiers = this.config.tiers || [];
      this.tierKey = null;
      this.tier = this.tiers.find(t => t.id === this.tierKey)?.size || 0;
      this.selection = new Map();
      this.choices = new Map();
      this.filter = 'all';
      this.finish = 'all';
      this.searchQuery = '';
      this.loadFailed = false;
      this.busy = false;
      this.cartUncertain = false;
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', {style:'currency', currency:this.config.currency || 'ZAR', maximumFractionDigits:2});
      this.listen = new AbortController();
      this.addEventListener('click', e => this.onClick(e), {signal:this.listen.signal});
      this.addEventListener('change', e => this.onChange(e), {signal:this.listen.signal});
      this.addEventListener('input',e=>{if(e.target.matches('[data-search]')&&!e.isComposing)this.updateSearch(e.target.value);},{signal:this.listen.signal});
      this.addEventListener('compositionend',e=>{if(e.target.matches('[data-search]'))this.updateSearch(e.target.value);},{signal:this.listen.signal});
      document.addEventListener('athena:offers-change',()=>this.syncOffers(),{signal:this.listen.signal});
      document.addEventListener('athena:offer-select',event=>this.selectOffer(event),{signal:this.listen.signal});
      this.querySelector('dialog').addEventListener('close', () => this.querySelector(window.matchMedia('(max-width: 760px)').matches?'[data-mobile-continue]':'[data-review]').focus(), {signal:this.listen.signal});
      this.querySelector('dialog').addEventListener('click', e => {if(e.target === this.querySelector('dialog')) {const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}}, {signal:this.listen.signal});
      const gallery=this.querySelector('[data-gallery]');
      gallery.addEventListener('close',()=>{this.galleryId=null;this.galleryPointer=null;this.querySelector('[data-gallery-open="'+CSS.escape(String(this.galleryOpenerId))+'"]')?.focus({preventScroll:true});},{signal:this.listen.signal});
      gallery.addEventListener('click',e=>{if(e.target===gallery){const r=gallery.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)gallery.close();}},{signal:this.listen.signal});
      gallery.addEventListener('keydown',e=>{
        if(e.target.closest('select,input,textarea'))return;
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.changeGalleryImage(this.galleryIndex+(e.key==='ArrowLeft'?-1:1));}
      },{signal:this.listen.signal});
      const stage=this.querySelector('[data-gallery-stage]');
      stage.addEventListener('pointerdown',e=>{
        if(e.target.closest('button')||!e.isPrimary)return;
        this.galleryPointer={id:e.pointerId,x:e.clientX,y:e.clientY};stage.setPointerCapture(e.pointerId);
      },{signal:this.listen.signal});
      stage.addEventListener('pointerup',e=>{
        const start=this.galleryPointer;this.galleryPointer=null;
        if(!start||start.id!==e.pointerId)return;
        const dx=e.clientX-start.x,dy=e.clientY-start.y;
        if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)this.changeGalleryImage(this.galleryIndex+(dx<0?1:-1));
      },{signal:this.listen.signal});
      stage.addEventListener('pointercancel',()=>{this.galleryPointer=null;},{signal:this.listen.signal});
      this.previewOffset = 0;
      this.resizeObserver = new ResizeObserver(() => this.updateTraySpacing());
      this.resizeObserver.observe(this.querySelector('[data-slots]').closest('aside'));
      const watchPreviewBar = () => {
        const bar = document.getElementById('PBarNextFrameWrapper');
        if (!bar || this.previewBar) return;
        this.previewBar = bar;
        this.previewResizeObserver = new ResizeObserver(() => {
          this.previewOffset = Math.ceil(bar.getBoundingClientRect().height);
          this.querySelector('.ab-tray').style.bottom = `${this.previewOffset}px`;
          this.updateTraySpacing();
        });
        this.previewResizeObserver.observe(bar);
        this.previewWatch?.disconnect();
      };
      this.previewWatch = new MutationObserver(watchPreviewBar);
      this.previewWatch.observe(document.body, {childList:true, subtree:true});
      watchPreviewBar();
      this.syncOffers();
    }
    disconnectedCallback() {clearTimeout(this.searchTimer);this.listen?.abort();this.resizeObserver?.disconnect();this.previewResizeObserver?.disconnect();this.previewWatch?.disconnect();this.previewBar=null;this.ready=false;
      const host=this.spacingHost;
      if(host&&!host.querySelector('athena-bundle-builder')){host.removeAttribute('data-ab-has-builder');host.style.removeProperty('--ab-bundle-space');}}
    syncOffers() {
      if(this.busy)return;
      const source=document.querySelector('athena-bundle-offers');
      const element=source?.querySelector('[data-ab-offer-data]');
      const data=element?JSON.parse(element.textContent):null;
      this.offers=source;
      const previousDefault=this.offerDefault;
      if(data)this.offerDefault=data.defaultTier;
      this.tiers=data?.tiers||[];
      this.config.unitPrice=data?.unitPrice||0;
      this.config.pricingMode=data?.pricingMode||'fixed';
      this.config.discountsConfirmed=Boolean(data?.discountsConfirmed);
      if(data)for(const [id,item] of this.selection){if(!this.eligible(item.variant))this.selection.delete(id);}
      if(this.tiers.length&&(!this.tiers.some(t=>t.id===this.tierKey)||(!this.selectedCount()&&previousDefault!==this.offerDefault)))this.tierKey=this.offerDefault||this.tiers[0]?.id;
      this.tier=this.tiers.find(t=>t.id===this.tierKey)?.size||0;
      const tierSelect=this.querySelector('[data-tier-select]');tierSelect.innerHTML=this.tiers.map(t=>`<option value="${escape(t.id)}">${escape(t.label)}</option>`).join('');tierSelect.hidden=this.tiers.length<2;
      this.querySelector('.ab-tray').hidden=!this.tier;
      this.querySelector('.ab-collection').hidden=!this.tiers.length;
      if(!this.tier||this.selectedCount()!==this.tier)this.querySelector('dialog').close();
      this.render();
      if(this.querySelector('dialog').open)this.review();
      this.updateTraySpacing();
    }
    selectOffer(event) {
      const {source,key,scroll}=event.detail;
      if(source!==this.offers||!this.tiers.some(t=>t.id===key))return;
      if(this.busy){this.offers.updateSelection(this.tierKey);return;}
      if(this.tierKey!==key)this.selectTier(key);
      if(scroll)this.scrollToPieces();
    }
    scrollToPieces() {
      const pieces=this.querySelector('.ab-collection');
      if(!pieces||pieces.hidden)return;
      const heading=this.querySelector('[data-collection-heading]');
      heading.setAttribute('tabindex','-1');
      heading.focus({preventScroll:true});
      pieces.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }
    selectTier(key) {
      if(this.busy)return;
      if(!this.tiers.some(t=>t.id===key))return;
      this.tierKey=key;this.tier=this.tiers.find(t=>t.id===key).size;
      this.render();this.announce(this.t('selected_count',{count:this.selectedCount(),total:this.tier}));
    }
    updateTraySpacing() {
      const host=document.body;
      host.setAttribute('data-ab-has-builder','');
      host.style.setProperty('--ab-bundle-space', `${this.tier?Math.ceil(this.querySelector('.ab-tray').getBoundingClientRect().height) + this.previewOffset + 24:0}px`);
      this.spacingHost=host;
    }
    t(key, values = {}) {return Object.entries(values).reduce((s,[k,v]) => s.split(`{${k}}`).join(String(v)), this.config.labels[key] || key);}
    money(cents) {return this.formatter.format(cents/100).replace(/([.,]00)(?=\s|$)/,'').replace(/^ZAR\s?/, 'R');}
    product(id) {return this.products.find(p => String(p.id) === String(id));}
    variant(p) {const chosen=this.choices.get(String(p.id));return p.variants.find(v => String(v.id) === chosen) || (p.variants.length === 1 ? p.variants[0] : null);}
    mixedPrices() {return this.config.pricingMode==='percentage';}
    eligible(v) {return v && v.available && Number.isSafeInteger(v.price) && v.price>=0 && (this.mixedPrices()||v.price===this.config.unitPrice) && this.config.currency==='ZAR';}
    discount() {return this.config.discountsConfirmed && this.config.currency==='ZAR' ? Math.min(100,Math.max(0,Number(this.tiers.find(t => t.id === this.tierKey)?.discount) || 0)) : 0;}
    offer(tier = this.tiers.find(t => t.id === this.tierKey)) {
      const mixed=this.mixedPrices();
      const regular=mixed?[...this.selection.values()].reduce((sum,item)=>sum+item.variant.price*item.quantity,0):(tier?.size||0)*this.config.unitPrice;
      const zar=this.config.currency==='ZAR';
      const fixed=zar&&!mixed?Math.max(0,Number(tier?.fixedPrice)||0):0;
      const pct=zar&&this.config.discountsConfirmed?Math.min(100,Math.max(0,Number(tier?.discount)||0)):0;
      const complete=this.selectedCount()===(tier?.size||0)&&Boolean(tier?.size);
      const price=fixed||regular-Math.round(regular*(mixed&&!complete?0:pct)/100);
      const hasDelivery=zar&&Boolean(tier?.showDelivery);
      const delivery=hasDelivery?Math.max(0,Number(tier?.deliveryPrice)||0):0;
      return {regular,price,delivery,hasDelivery,total:price+delivery};
    }
    total() {
      const regular=[...this.selection.values()].reduce((n,s)=>n+s.variant.price*s.quantity,0);
      const offer=this.offer();
      const complete=this.selectedCount()===this.tier&&this.tier>0;
      return {regular,payable:this.mixedPrices()||complete?offer.price:regular-Math.round(regular*this.discount()/100)};
    }
    deliveryText(offer,compact=false) {
      if(!offer.hasDelivery)return this.t('delivery_checkout');
      return this.t(compact?(offer.delivery?'quote_delivery':'quote_included'):(offer.delivery?'delivery_extra':'delivery_included'),{price:this.money(offer.price),delivery:this.money(offer.delivery)});
    }
    announce(text) {this.querySelector('[data-announcement]').textContent=text;}
    onChange(event) {
      if(this.busy)return;
      const el=event.target;
      if(el.matches('[data-tier-select]'))this.selectTier(el.value);
      if(el.matches('[data-finish]')) {this.finish=el.value;this.renderCards();}
      if(el.matches('[data-gallery-variant]')) {this.choices.set(this.galleryId,el.value);this.renderCards();this.renderGalleryDetails();}
      if(el.matches('[data-variant]')) {this.choices.set(el.dataset.variant,el.value);this.renderCards();}
    }
    onClick(event) {
      const el=event.target.closest('button');
      if(!el || !this.contains(el) || el.disabled) return;
      if(el.hasAttribute('data-gallery-open')) {this.openGallery(el.dataset.galleryOpen);return;}
      if(el.hasAttribute('data-gallery-close')) {this.querySelector('[data-gallery]').close();return;}
      if(el.hasAttribute('data-gallery-step')) {this.changeGalleryImage(this.galleryIndex+Number(el.dataset.galleryStep));return;}
      if(el.hasAttribute('data-gallery-thumb')) {this.changeGalleryImage(Number(el.dataset.galleryThumb));return;}
      if(el.hasAttribute('data-filter')) {this.filter=el.dataset.filter;this.renderCards();}
      if(el.hasAttribute('data-reset-filters')) {this.filter='all';this.finish='all';this.querySelector('[data-finish]').value='all';this.updateSearch('');this.querySelector('[data-search]')?.focus({preventScroll:true});}
      if(el.hasAttribute('data-clear-search')) {this.updateSearch('');this.querySelector('[data-search]')?.focus({preventScroll:true});}
      if(el.hasAttribute('data-add')) this.addProduct(el.dataset.add,el.dataset.context);
      if(el.hasAttribute('data-decrease')) this.removeOne(el.dataset.decrease);
      if(el.hasAttribute('data-remove')) this.removeOne(el.dataset.remove);
      if(el.hasAttribute('data-review')) this.review();
      if(el.hasAttribute('data-mobile-continue')) this.continueBuilding();
      if(el.hasAttribute('data-close')) this.querySelector('dialog').close();
      if(el.hasAttribute('data-add-cart')) this.addToCart();
      if(el.hasAttribute('data-load-more')) {if(this.searchQuery?.trim())this.loadSearchPages();else this.loadMore();}
    }
    selectedCount() {return [...this.selection.values()].reduce((count,item)=>count+item.quantity,0);}
    variantQuantity(variant) {return variant?this.selection.get(String(variant.id))?.quantity||0:0;}
    productQuantity(product) {return [...this.selection.values()].reduce((count,item)=>count+(String(item.product.id)===String(product.id)?item.quantity:0),0);}
    itemName(product,variant) {return variant&&variant.title!=='Default Title'&&variant.title!==this.t('one_size')?`${product.title} — ${variant.title}`:product.title;}
    quantityLimit(variant) {return variant?.inventoryLimit==null?Infinity:Math.max(0,Number(variant.inventoryLimit)-(Number(variant.cartQuantity)||0));}
    canAdd(variant) {return !this.busy&&Boolean(this.tier)&&this.selectedCount()<this.tier&&this.eligible(variant)&&this.variantQuantity(variant)<this.quantityLimit(variant);}
    selectionMessage(text) {this.announce(text);if(this.galleryId)this.querySelector('[data-gallery-status]').textContent=text;}
    addProduct(id,context='card') {
      if(this.busy||!this.tier||this.selectedCount()>=this.tier)return;
      const product=this.product(id);if(!product)return;
      const variant=this.variant(product);
      if(!variant){
        const select=context==='gallery'?this.querySelector('[data-gallery-variant]'):this.querySelector(`[data-variant="${CSS.escape(String(id))}"]`);
        select?.setAttribute('aria-invalid','true');select?.focus();
        this.selectionMessage(this.t('choose_variant_for',{name:product.title}));return;
      }
      if(!this.canAdd(variant)){this.selectionMessage(this.t('quantity_limit'));return;}
      const key=String(variant.id),quantity=this.variantQuantity(variant)+1;
      this.selection.set(key,{product,variant,quantity});
      this.render();this.selectionMessage(this.t('added',{name:this.itemName(product,variant)}));
    }
    removeOne(id) {
      if(this.busy)return;
      const entry=this.selection.get(String(id));if(!entry)return;
      const slotFocused=document.activeElement?.hasAttribute?.('data-remove');
      if(entry.quantity>1)entry.quantity--;else this.selection.delete(String(id));
      this.render();this.selectionMessage(this.t('removed',{name:this.itemName(entry.product,entry.variant)}));
      if(slotFocused)(this.querySelector(`[data-remove="${CSS.escape(String(id))}"]`)||this.querySelector(`[data-gallery-open="${CSS.escape(String(entry.product.id))}"]`))?.focus({preventScroll:true});
    }
    quantityControls(product,variant,context='card') {
      const id=String(product.id),quantity=this.variantQuantity(variant),name=this.itemName(product,variant);
      const any=product.variants.some(v=>this.eligible(v)&&this.quantityLimit(v)>0);
      const blocked=this.busy||!this.tier||this.selectedCount()>=this.tier||!any||(variant&&!this.canAdd(variant));
      const prefix=`qty-${context}-${id}`;
      const action=!any||(variant&&!this.eligible(variant))?this.t('unavailable'):this.selectedCount()>=this.tier?this.t('bundle_full'):variant&&quantity>=this.quantityLimit(variant)?this.t('quantity_limit'):this.t('add');
      const addAttributes=`data-add="${escape(id)}" data-context="${context}" data-focus="${escape(prefix)}-add" aria-label="${escape(this.t('increase_named',{name}))}" ${blocked?'disabled':''}`;
      if(!quantity)return `<button type="button" class="${context==='gallery'?'ab-primary ab-gallery-add':'ab-card-add'}" ${addAttributes}><span>${escape(action)}</span><span aria-hidden="true">+</span></button>`;
      return `<div class="ab-quantity" role="group" aria-label="${escape(this.t('quantity_for',{name}))}"><button type="button" data-decrease="${escape(variant.id)}" data-focus="${escape(prefix)}-remove" aria-label="${escape(this.t('decrease_named',{name}))}" ${this.busy?'disabled':''}>−</button><span class="ab-quantity-value" aria-live="polite">${quantity}</span><button type="button" ${addAttributes}>+</button></div>`;
    }
    restoreQuantityFocus(focus) {
      if(!focus)return;
      let target=this.querySelector(`[data-focus="${CSS.escape(focus)}"]`);
      if(!target&&focus.endsWith('-remove'))target=this.querySelector(`[data-focus="${CSS.escape(focus.replace(/-remove$/,'-add'))}"]`);
      if(target?.disabled&&focus.endsWith('-add'))target=this.querySelector(`[data-focus="${CSS.escape(focus.replace(/-add$/,'-remove'))}"]`)||target;
      target?.focus({preventScroll:true});
    }

    image(p,cls='') {return p.image ? `<img class="${cls}" src="${escape(p.image)}" alt="${escape(p.title)}" loading="lazy" width="480" height="540">` : '';}
    galleryImages(product) {
      const images=(product.images||[]).filter(image=>image&&image.src);
      return images.length?images:(product.image?[{src:product.image,thumb:product.image,alt:product.title}]:[]);
    }
    openGallery(id) {
      const product=this.product(id);if(!product)return;
      this.galleryId=String(id);this.galleryOpenerId=id;this.galleryIndex=0;this.galleryPhotos=this.galleryImages(product);
      this.querySelector('[data-gallery-title]').textContent=product.title;
      this.querySelector('[data-gallery-meta]').textContent=product.subtitle||product.type||this.t('the_edit');
      this.querySelector('[data-gallery-status]').textContent='';
      this.querySelector('[data-gallery-thumbs]').innerHTML=this.galleryPhotos.map((photo,index)=>`<button type="button" class="ab-gallery-thumb" data-gallery-thumb="${index}" aria-pressed="false" aria-label="${escape(this.t('gallery_photo',{number:index+1}))}"><img src="${escape(photo.thumb||photo.src)}" alt="" loading="lazy" width="80" height="90"></button>`).join('');
      this.changeGalleryImage(0);
      this.renderGalleryDetails();
      this.querySelector('[data-gallery]').showModal();
    }
    changeGalleryImage(index) {
      const count=this.galleryPhotos?.length||0;
      this.galleryIndex=count?((index%count)+count)%count:0;
      const photo=this.galleryPhotos?.[this.galleryIndex],product=this.product(this.galleryId);
      this.querySelector('[data-gallery-image]').innerHTML=photo?`<img src="${escape(photo.src)}" alt="${escape(photo.alt||product?.title||'')}" width="${Number(photo.width)||1000}" height="${Number(photo.height)||1200}" draggable="false">`:`<p>${escape(this.t('gallery_empty'))}</p>`;
      const counter=this.querySelector('[data-gallery-count]');counter.hidden=count<2;counter.textContent=this.t('gallery_count',{number:this.galleryIndex+1,total:count});
      this.querySelector('[data-gallery-thumbs]').hidden=count<2;
      this.querySelectorAll('[data-gallery-step]').forEach(button=>{button.hidden=count<2;});
      this.querySelectorAll('[data-gallery-thumb]').forEach(button=>{
        const active=Number(button.dataset.galleryThumb)===this.galleryIndex;button.setAttribute('aria-pressed',String(active));
        if(active&&this.querySelector('[data-gallery]').open)button.scrollIntoView({block:'nearest',inline:'nearest'});
      });
    }
    renderGalleryDetails() {
      const product=this.product(this.galleryId);if(!product)return;
      const variant=this.variant(product),focus=document.activeElement?.dataset?.focus;
      this.querySelector('[data-gallery-price]').textContent=this.t('gallery_individual',{price:this.money(variant?.price??product.variants[0]?.price??this.config.unitPrice)});
      this.querySelector('[data-gallery-offer]').textContent=this.t(this.mixedPrices()?'gallery_percentage_offer':'gallery_offer',{count:this.tier,percent:this.discount(),price:this.money(this.offer().price)});
      this.querySelector('[data-gallery-delivery]').textContent=this.deliveryText(this.offer(),true);
      const options=this.querySelector('[data-gallery-options]'),optionFocused=options.contains(document.activeElement);
      options.innerHTML=product.variants.length>1?`<label class="ab-variant">${escape(product.optionLabel||this.t('options'))}<select data-gallery-variant aria-label="${escape(this.t('choose_variant_for',{name:product.title}))}" ${this.busy?'disabled':''}><option value="">${escape(this.t('choose_option'))}</option>${product.variants.map(v=>`<option value="${escape(v.id)}" ${this.eligible(v)?'':'disabled'} ${String(variant?.id)===String(v.id)?'selected':''}>${escape(v.title)}${this.eligible(v)?'':` — ${escape(this.t('unavailable'))}`}</option>`).join('')}</select></label>`:`<p class="ab-one-size">${escape(variant?.title&&variant.title!=='Default Title'?variant.title:this.t('one_size'))}</p>`;
      this.querySelector('[data-gallery-actions]').innerHTML=this.quantityControls(product,variant,'gallery');
      const lines=[...this.selection.values()].filter(item=>String(item.product.id)===String(product.id));
      this.querySelector('[data-gallery-selection]').textContent=product.variants.length>1?lines.map(item=>`${item.variant.title} × ${item.quantity}`).join(' · '):'';
      if(optionFocused)options.querySelector('select')?.focus({preventScroll:true});
      if(focus?.startsWith('qty-gallery-'))this.restoreQuantityFocus(focus);
    }


    normalizeSearch(value) {return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}
    updateSearch(value) {
      this.searchQuery=String(value);
      const input=this.querySelector('[data-search]');
      if(input&&input.value!==this.searchQuery)input.value=this.searchQuery;
      clearTimeout(this.searchTimer);
      this.renderCards();
      if(this.searchQuery.trim()&&this.config.nextPage)this.searchTimer=setTimeout(()=>this.loadSearchPages(),200);
    }
    async loadSearchPages() {
      if(this.searchLoading)return;
      this.searchLoading=true;
      try {
        while(this.searchQuery?.trim()&&this.config.nextPage&&!this.listen?.signal.aborted){
          if(!await this.loadMore())break;
        }
      }finally{this.searchLoading=false;}
    }
    filteredProducts() {
      const filterDefinition=this.config.filters.find(f=>f.id===this.filter);
      const words=this.normalizeSearch(this.searchQuery).split(/\s+/).filter(Boolean);
      return this.products.filter(p=>{
        const terms=[p.title,p.type,...(p.tags||[])].join(' ').toLowerCase();
        const category=this.filter==='all'||filterDefinition?.keywords.some(k=>{const word=k.trim().toLowerCase();return word&&new RegExp(`(^|\\W)${word.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')}s?(\\W|$)`,'i').test(terms);});
        const finishWord=this.config.finishes.find(f=>f.id===this.finish)?.keyword?.trim();
        const finish=this.finish==='all'||Boolean(finishWord&&terms.includes(finishWord));
        const searchable=this.normalizeSearch([p.title,p.type,...(p.tags||[]),...(p.variants||[]).map(v=>v.title)].join(' '));
        return category&&finish&&words.every(word=>searchable.includes(word));
      });
    }
    renderCards() {
      const focus=document.activeElement?.dataset?.focus;
      const visible=this.filteredProducts();
      this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.filter)));
      const searching=Boolean(this.searchQuery?.trim()&&this.config.nextPage);
      const clear=this.querySelector('[data-clear-search]');if(clear)clear.hidden=!this.searchQuery;
      this.querySelector('[data-result-count]').textContent=this.t(searching?(this.loadFailed?'search_partial':'search_loading'):'result_count',{count:visible.length});
      this.querySelector('[data-grid]').innerHTML=visible.map(p=>{
        const id=String(p.id),selected=this.productQuantity(p),v=this.variant(p),choose=p.variants.length>1;
        return `<article class="ab-card"><button type="button" class="ab-card-picture" data-gallery-open="${escape(id)}" data-focus="gallery-${escape(id)}" aria-haspopup="dialog" aria-label="${escape(this.t('gallery_open',{name:p.title}))}">${this.image(p)}${selected?`<span class="ab-selected-badge">✓ ${escape(this.t('quantity_selected',{count:selected}))}</span>`:''}</button><p class="ab-card-meta">${escape(p.subtitle||p.type||this.t('the_edit'))}</p><div class="ab-card-heading"><h3>${escape(p.title)}</h3><strong>${escape(this.money(v?.price??p.variants[0]?.price??this.config.unitPrice))}</strong></div>${choose?`<label class="ab-variant">${escape(p.optionLabel||this.t('options'))}<select aria-label="${escape(this.t('choose_variant_for',{name:p.title}))}" data-variant="${escape(id)}" data-focus="variant-${escape(id)}" ${this.busy?'disabled':''}><option value="">${escape(this.t('choose_option'))}</option>${p.variants.map(x=>`<option value="${escape(x.id)}" ${this.eligible(x)?'':'disabled'} ${String(v?.id)===String(x.id)?'selected':''}>${escape(x.title)}${this.eligible(x)?'':` — ${escape(this.t('unavailable'))}`}</option>`).join('')}</select></label>`:`<p class="ab-one-size">${escape(v?.title&&v.title!=='Default Title'?v.title:this.t('one_size'))}</p>`}${this.quantityControls(p,v)}</article>`;
      }).join('');

      this.querySelector('[data-empty]').hidden=visible.length>0||searching;
      this.querySelector('[data-empty] h3').textContent=this.products.length?this.t('empty_title'):this.t('coming_soon');
      this.querySelector('[data-empty] p').textContent=this.products.length?this.t('empty_text'):this.t('coming_soon_text');
      this.querySelector('[data-reset-filters]').hidden=!this.products.length;
      this.querySelector('[data-load-more]').hidden=!this.config.nextPage;
      this.restoreQuantityFocus(focus);
    }
    renderCollectionHeading() {
      const heading=this.querySelector('[data-collection-heading]');
      heading.textContent=this.tiers.find(t=>t.id===this.tierKey)?.heading||heading.dataset.defaultHeading;
    }
    render() {
      this.renderCollectionHeading();
      this.offers?.updateSelection?.(this.tierKey);
      this.querySelector('[data-tier-select]').value=this.tierKey||'';
      const count=this.t('selected_count',{count:this.selectedCount(),total:this.tier});
      this.querySelector('[data-count]').textContent=count;this.querySelector('[data-tray-count]').textContent=count;
      const slots=[...this.selection.entries()].flatMap(([id,s])=>Array.from({length:s.quantity},()=>`<div class="ab-slot" title="${escape(this.itemName(s.product,s.variant))}">${this.image(s.product)}<button type="button" data-remove="${escape(id)}" aria-label="${escape(this.t('decrease_named',{name:this.itemName(s.product,s.variant)}))}" ${this.busy?'disabled':''}>×</button></div>`));

      for(let i=this.selectedCount();i<this.tier;i++)slots.push(`<div class="ab-slot" aria-label="${escape(this.t('empty_slot',{number:i+1}))}">${i+1}</div>`);
      this.querySelector('[data-slots]').innerHTML=slots.join('');
      const {regular}=this.total(), offer=this.offer();
      this.querySelector('[data-total]').textContent=this.money(offer.total);
      this.querySelector('[data-total-label]').textContent=this.t('bundle_total');
      this.querySelector('[data-tray-breakdown]').textContent=this.deliveryText(offer,true);
      const remaining=this.tier-this.selectedCount(), review=this.querySelector('[data-review]');
      this.querySelector('[data-mobile-tray-count]').textContent=count;
      this.querySelector('[data-mobile-tray-price]').textContent=this.money(offer.price);
      const mobileAction=this.querySelector('[data-mobile-continue]');
      mobileAction.disabled=this.busy||!this.tier;
      mobileAction.innerHTML=escape(remaining===0?this.t('review'):remaining<0?this.t('remove_more',{count:-remaining}):this.t('continue_building'))+'<span aria-hidden="true">→</span>';
      review.disabled=this.busy||!this.tier||remaining!==0;
      this.querySelector('[data-tier-select]').disabled=this.busy;
      review.innerHTML=`${escape(remaining>0?this.t('choose_more',{count:remaining}):remaining<0?this.t('remove_more',{count:-remaining}):this.t('review'))}<span aria-hidden="true">→</span>`;
      this.querySelector('[data-tray-hint]').textContent=remaining>0?this.t('choose_more',{count:remaining}):remaining<0?this.t('remove_more',{count:-remaining}):this.t('bundle_ready');
      this.querySelector('[data-tray-note]').textContent=this.selectedCount()===0?this.t('selection_note'):remaining===0?this.t('selection_complete',{regular:this.money(regular),saving:this.money(Math.max(0,regular-offer.price))}):this.t('selection_partial',{regular:this.money(regular)});
      this.renderCards();
      if(this.galleryId)this.renderGalleryDetails();
    }
    continueBuilding() {
      if(this.busy||!this.tier)return;
      if(this.selectedCount()===this.tier){this.review();return;}
      this.scrollToPieces();
      if(this.selectedCount()>this.tier)this.announce(this.t('remove_more',{count:this.selectedCount()-this.tier}));
    }
    review() {
      if(this.busy||!this.tier||this.selectedCount()!==this.tier) return;
      this.querySelector('[data-review-items]').innerHTML=[...this.selection.values()].map(s=>`<div class="ab-review-item">${this.image(s.product)}<div><p>${escape(s.product.title)}</p><small>${escape(s.variant.title==='Default Title'?this.t('one_size'):s.variant.title)} × ${s.quantity}</small></div><strong>${escape(this.money(s.variant.price*s.quantity))}</strong></div>`).join('');
      this.querySelector('[data-review-total]').textContent=this.money(this.offer().total);
      const offer=this.offer();
      const discountNote=this.mixedPrices()?this.t('review_discount',{regular:this.money(offer.regular),saving:this.money(offer.regular-offer.price),percent:this.discount()})+' ':'';
      this.querySelector('[data-review-note]').textContent=discountNote+`${this.deliveryText(this.offer(),true)}. ${this.config.preview?this.t('preview_checkout'):this.t('checkout_note')}`;
      const enabled=this.config.cartEnabled&&!this.config.preview;
      const button=this.querySelector('[data-add-cart]');button.disabled=!enabled||this.cartUncertain;button.textContent=enabled?this.t('add_cart'):this.t('preview_only');
      this.querySelector('dialog').showModal();
    }
    loadMore() {
      if(!this.config.nextPage)return Promise.resolve(false);
      if(this.loading)return this.loadPromise;
      this.loading=true;this.loadFailed=false;
      const button=this.querySelector('[data-load-more]'),nextPage=this.config.nextPage;
      const controller=this.listen,signal=controller?.signal;
      button.disabled=true;button.textContent=this.t('loading');
      this.querySelector('[data-load-error]').textContent='';
      this.renderCards();
      this.loadPromise=(async()=>{
        try {
          const url=new URL(nextPage,location.origin);url.searchParams.set('section_id',this.config.sectionId);
          const response=await fetch(url,{credentials:'same-origin',signal:signal?AbortSignal.any([signal,AbortSignal.timeout(15000)]):AbortSignal.timeout(15000)});
          if(!response.ok)throw new Error();
          const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
          const data=JSON.parse(documentFragment.querySelector('[data-ab-data]').textContent);
          if(!Array.isArray(data.products)||(data.nextPage&&data.nextPage===nextPage))throw new Error();
          if(signal?.aborted)return false;
          const ids=new Set(this.products.map(p=>String(p.id)));
          this.products.push(...data.products.filter(p=>{const id=String(p.id);if(ids.has(id))return false;ids.add(id);return true;}));
          this.config.nextPage=data.nextPage;
          return true;
        }catch {
          if(!signal?.aborted){this.loadFailed=true;this.querySelector('[data-load-error]').textContent=this.t('load_error');}
          return false;
        }finally {
          if(!signal?.aborted){this.loading=false;button.disabled=false;button.textContent=this.t('load_more');this.renderCards();}
        }
      })();
      return this.loadPromise;
    }
    cartResponseMatches(expected,actual) {
      if(!Array.isArray(actual))return false;
      const quantities=new Map();
      for(const item of actual){
        const id=String(item.variant_id??item.id),match=expected.find(entry=>String(entry.id)===id);
        if(!match||!Number.isInteger(item.quantity)||item.quantity<1||item.properties?._athena_bundle!==match.properties._athena_bundle)return false;
        quantities.set(id,(quantities.get(id)||0)+item.quantity);
      }
      return expected.every(item=>quantities.get(String(item.id))===item.quantity);
    }
    async addToCart() {
      if(!this.tier||this.busy||this.cartUncertain||this.config.preview||!this.config.cartEnabled||this.selectedCount()!==this.tier)return;
      const entries=[...this.selection.values()].map(item=>({...item})),size=this.tier;
      if(entries.some(item=>!this.eligible(item.variant)||!Number.isInteger(item.quantity)||item.quantity<1))return;
      this.busy=true;this.render();
      const button=this.querySelector('[data-add-cart]'),error=this.querySelector('[data-cart-error]');
      button.disabled=true;button.textContent=this.t('checking');error.textContent='';
      let sent=false;
      try {
        let cartItems=[];
        if(entries.some(item=>item.variant.inventoryLimit!=null)){
          const cartResponse=await fetch(`${this.config.root}cart.js`,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
          if(!cartResponse.ok)throw new Error();
          const cart=await cartResponse.json();if(!Array.isArray(cart.items))throw new Error();cartItems=cart.items;
        }
        const products=new Map();
        for(const entry of entries) {
          const handle=entry.product.handle;
          if(!products.has(handle)){
            const response=await fetch(`${this.config.root}products/${encodeURIComponent(handle)}.js`,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
            if(!response.ok)throw new Error(this.t('stock_error'));
            products.set(handle,await response.json());
          }
          const variant=products.get(handle).variants.find(v=>String(v.id)===String(entry.variant.id));
          const existing=cartItems.filter(item=>String(item.variant_id??item.id)===String(entry.variant.id)).reduce((total,item)=>total+item.quantity,0);
          if(!variant||!variant.available||variant.price!==entry.variant.price||(entry.variant.inventoryLimit!=null&&entry.quantity+existing>entry.variant.inventoryLimit))throw new Error(this.t('stock_error'));
        }
        const group=crypto.randomUUID();
        const items=entries.map(item=>({id:item.variant.id,quantity:item.quantity,properties:{'_athena_bundle':group,'_athena_bundle_size':String(size)}}));
        sent=true;button.textContent=this.t('adding');
        const response=await fetch(`${this.config.root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:AbortSignal.timeout(20000)});
        if(!response.ok)throw new Error(this.t('cart_error'));
        const result=await response.json();if(!this.cartResponseMatches(items,result.items))throw new Error(this.t('cart_error'));
        location.assign(this.config.cartUrl);
      }catch(e) {
        if(sent){this.cartUncertain=true;error.textContent=this.t('cart_error');this.querySelector('[data-cart-link]').hidden=false;}
        else error.textContent=e.message===this.t('stock_error')?e.message:this.t('connection_error');
        this.busy=false;this.render();button.disabled=this.cartUncertain;button.textContent=this.t('add_cart');
      }
    }


  }
  customElements.define('athena-bundle-builder',AthenaBundleBuilder);
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athena-bundle-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('athena-bundle-offers'))return;
  class AthenaBundleOffers extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      const data=this.querySelector('[data-ab-offer-data]');
      if(!data)return;
      this.ready=true;this.config=JSON.parse(data.textContent);
      this.listen=new AbortController();
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-tier]'))document.dispatchEvent(new CustomEvent('athena:offer-select',{detail:{source:this,key:event.target.value}}));
      },{signal:this.listen.signal});
      this.addEventListener('click',event=>{
        if(event.target.matches('[data-tier]')&&!event.target.disabled)document.dispatchEvent(new CustomEvent('athena:offer-select',{detail:{source:this,key:event.target.value,scroll:true}}));
      },{signal:this.listen.signal});
      this.renderPrices();
      document.dispatchEvent(new CustomEvent('athena:offers-change'));
    }
    disconnectedCallback(){this.listen?.abort();this.ready=false;document.dispatchEvent(new CustomEvent('athena:offers-change'));}
    updateSelection(key){this.querySelectorAll('[data-tier]').forEach(input=>{input.checked=input.value===key;});}
    renderPrices(){
      const data=this.config;
      const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-ZA',{style:'currency',currency:data.currency||'ZAR',maximumFractionDigits:2});
      const money=cents=>formatter.format(cents/100).replace(/([.,]00)(?=\s|$)/,'').replace(/^ZAR\s?/,'R');
      const label=(key,values={})=>Object.entries(values).reduce((text,[key,value])=>text.split('{'+key+'}').join(String(value)),data.labels[key]||'');
      for(const tier of data.tiers){
        const regular=tier.size*data.unitPrice,zar=data.currency==='ZAR';
        const discount=zar&&data.discountsConfirmed?Math.min(100,Math.max(0,Number(tier.discount)||0)):0;
        const price=(zar?Math.max(0,Number(tier.fixedPrice)||0):0)||regular-Math.round(regular*discount/100);
        const hasDelivery=zar&&Boolean(tier.showDelivery),delivery=hasDelivery?Math.max(0,Number(tier.deliveryPrice)||0):0;
        const mixed=data.pricingMode==='percentage';
        this.querySelector('[data-tier-price="'+CSS.escape(tier.id)+'"]').textContent=mixed?label('percentage_offer',{percent:discount}):money(price);
        this.querySelector('[data-tier-detail="'+CSS.escape(tier.id)+'"]').textContent=tier.detail||(hasDelivery?label(delivery?'delivery_extra':'delivery_included',{delivery:money(delivery)}):label('delivery_checkout'));
        this.querySelector('[data-tier-inclusive="'+CSS.escape(tier.id)+'"]').textContent=mixed?label('percentage_total',{count:tier.size,percent:discount}):label('tier_total',{total:money(price+delivery)});
      }
    }
  }
  customElements.define('athena-bundle-offers',AthenaBundleOffers);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
